import { grpc, common } from '@aitmed/aitmed-grpc-sdk-test'
import { CreateEdgeArgs, RetrieveEdgeArgs } from './types'
import utils from '../../utils'


const edgesServices = (function () {
    const services = {
        createEdge,
        retrieveEdge,
        updateEdge,
        deleteEdge,
        attachDocument,
    }
    /**
     * 
     * @param param0 
     * 
     * used to create an edge
     */
    async function createEdge({
        etype,
        apiVersion,
        name,
        callBack,
    }: CreateEdgeArgs) {
        let jwt
        if (localStorage.getItem('jwt')) {
            jwt = localStorage.getItem('jwt')
        }
        try {
            const { deat } = await grpc.v1beta1.createEdge({ etype, apiVersion, jwt, name, callBack })
            return deat
        } catch (error) {
            throw error
        }
    }

    /**
     * 
     * @param param0 
     * 
     * used to retrieve an edge
     */
    async function retrieveEdge({
        eid,
        apiVersion,
        callBack
    }: RetrieveEdgeArgs) {
        let jwt
        if (localStorage.getItem('jwt')) {
            jwt = localStorage.getItem('jwt')
        }
        try {
            const deat = await grpc.v1beta1.retrieveEdge({ eid, apiVersion, jwt, callBack })
            return deat
        } catch (error) {
            throw error
        }
    }

    /**
     * 
     * @param args 
     * 
     * used to update an edge
     */
    function updateEdge(args: any) {
        console.log(args)
        return 'edge'
    }

    /**
     * 
     * @param args 
     * 
     * used to delete an edge
     */
    function deleteEdge(args: any) {
        console.log(args)
        return 'edge'
    }

    return services


    async function attachDocument({ fileName, file, dataSize }: any) {
        let name = { fileName, dataSize }
        let nameJSON = JSON.stringify(name)
        let jwt
        if (localStorage.getItem('jwt')) {
            jwt = localStorage.getItem('jwt')
        }
        try {
            const { file_id } = await grpc.v1beta1.createEdge({ etype: common.codes.EtypeCode.generalEvent, apiVersion: 'v1beta1', jwt, name: nameJSON })
            const response = await utils.fileUpload({ file, fileName: file_id })
            return response
        } catch (error) {
            throw error
        }
    }

})()

export default edgesServices